import PropTypes from 'prop-types';
import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { PopoverContentInternal } from './popover-content-internal.component.js';
import { PopoverDialog } from './popover-dialog.component.js';
import { useSwanPopover } from './popover.context.js';
import { filterProps } from '../core/core.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    dialog: PropTypes.bool,
    fullBleed: PropTypes.bool
};
const PopoverContent = renderWithRef('PopoverContent', {}, (props, ref)=>{
    const { children , dialog , fullBleed , hideArrow , placement  } = props;
    const { overlayState , popoverPlacement  } = useSwanPopover();
    const filteredProps = filterProps(props, Object.keys(propTypes));
    var _ref;
    const popoverProps = _object_spread_props(_object_spread({}, filteredProps), {
        hideArrow,
        placement: (_ref = placement !== null && placement !== void 0 ? placement : popoverPlacement) !== null && _ref !== void 0 ? _ref : 'top',
        fullBleed: fullBleed !== null && fullBleed !== void 0 ? fullBleed : undefined,
        role: !dialog ? 'tooltip' : undefined,
        children: dialog ? /*#__PURE__*/ React.createElement(PopoverDialog, null, children) : children
    });
    const onKeyDown = useCallback((event)=>{
        if (event.key === 'Escape') {
            overlayState.close();
        }
    }, [
        overlayState
    ]);
    useEffect(()=>{
        // only add the event listener if this is not a dialog popover - the PopoverDialog handles esc functionality already
        if (dialog) {
            return;
        }
        if (overlayState.isOpen) {
            document.addEventListener('keydown', onKeyDown);
        } else {
            document.removeEventListener('keydown', onKeyDown);
        }
        return ()=>{
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [
        dialog,
        overlayState.isOpen,
        onKeyDown
    ]);
    // eslint-disable-next-line react/jsx-no-undef
    return overlayState.isOpen ? /*#__PURE__*/ React.createElement(PopoverContentInternal, _object_spread_props(_object_spread({}, popoverProps), {
        ref: ref
    })) : null;
});

export { PopoverContent };
